module.exports = __webpack_public_path__ + "img/Sunnyvale.a49fadc3.jpg";